import React from 'react';
import {
    Input,
    Select,
    Icon
} from 'antd';

import SelectPlaceHolder from '../../../components/SelectPlaceHolder';

class Filters extends React.Component {
    render() {
        return (
            <div className="filfer-container">
                <div className="row">
                    <div className="col-md-2">
                        <Input
                            prefix={<Icon type="filter" style={{ color: 'rgba(0,0,0,.25)' }} />}
                            value={this.props.filter.codigo} //STATE PROPERTY
                            onChange={(e) => this.props.onChange("codigo", e.target.value)}
                            onKeyUp={this.props.onKeyUpSearch}
                            placeholder="Filtrar por codigo"
                            autoComplete="off"
                        />
                    </div>
                    <div className="col-md-2">
                    <Input
                            prefix={<Icon type="filter" style={{ color: 'rgba(0,0,0,.25)' }} />}
                            value={this.props.filter.nombre} //STATE PROPERTY
                            onChange={(e) => this.props.onChange("nombre", e.target.value)}
                            onKeyUp={this.props.onKeyUpSearch}
                            placeholder="Filtrar por nombre"
                            autoComplete="off"
                        />
                    </div>
                    <div className="col-md-2">
                    <Select
                            showSearch labelInValue
                            value={
                                this.props.filter.idEstablecimiento ?
                                    { key: this.props.filter.idEstablecimiento } : undefined
                            }
                            placeholder={<SelectPlaceHolder label="Filtrar por establecimiento" />}
                            onChange={(option) => this.props.onChange("idEstablecimiento", option.key)} //STATE PROPERTY
                            optionFilterProp="children"
                        >
                            {this.props.establecimientos.map(item => ( //STATE DATA
                                <Select.Option value={item.id} key={item.id}>{item.nombre}</Select.Option>
                            ))}
                        </Select>
                    </div>
                    <div className="col-md-2">
                        <Select
                            showSearch labelInValue
                            value={
                                this.props.filter.idAlmacen ?
                                    { key: this.props.filter.idAlmacen } : undefined
                            }
                            placeholder={<SelectPlaceHolder label="Filtrar por almacén" />}
                            onChange={(option) => this.props.onChange("idAlmacen", option.key)} //STATE PROPERTY
                            optionFilterProp="children"
                        >
                            {this.props.almacenes.map(item => ( //STATE DATA
                                <Select.Option value={item.id} key={item.id}>{item.nombre}</Select.Option>
                            ))}
                        </Select>
                    </div>
                    <div className="col-md-2">
                        <Select
                            showSearch labelInValue
                            value={
                                this.props.filter.estado ?
                                    { key: this.props.filter.estado } : undefined
                            }
                            placeholder={<SelectPlaceHolder label="Filtrar por estado" />}
                            onChange={(option) => this.props.onChange("estado", option.key)} //STATE PROPERTY
                            optionFilterProp="children"
                        >
                            {this.props.estados.map(item => ( //STATE DATA
                                <Select.Option value={item.id} key={item.id}>{item.nombre}</Select.Option>
                            ))}
                        </Select>
                    </div>
                </div>
            </div>
        );
    }

}

export default Filters;